import { inject, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import {
  getFormattedCategory,
  isProductCategory,
  isProductCategoryEmobility,
  isProductCategoryInternet,
  translateCategoryInstant,
} from '@mwe/utils';
import { Sparte } from '@mwe/models';
import { ProfileService } from '@mwe/services';
import { FeatureToggleEnum, ProductCategoryEnum } from '@mwe/constants';

@Pipe({ name: 'translateCategory' })
export class TranslateCategoryPipe implements PipeTransform {
  private readonly translateService = inject(TranslateService);
  private readonly profileService = inject(ProfileService);

  transform(category: string, useFwTariffClassTranslation?: boolean): string {
    const isNewInternetProcessEnabled = this.profileService.isFeatureToggleEnabled(FeatureToggleEnum.INTERNET_V2_ENABLED);
    if (isNewInternetProcessEnabled && isProductCategory(category, ProductCategoryEnum.INTERNET)) {
      return this.translateService.instant(`products.category.${category.toLowerCase()}_new`);
    }

    if (useFwTariffClassTranslation) {
      return this.translateService.instant(`products.category.details.${category.toLowerCase()}`);
    }
    if (category === Sparte.StromGas) {
      return this.translateService.instant(`products.category.${category.toLowerCase()}`);
    }
    const translation = translateCategoryInstant(category, this.translateService);
    if (isProductCategoryInternet(category) || isProductCategoryEmobility(category)) {
      return translation;
    }
    return getFormattedCategory(translation);
  }
}
